import axios from 'axios';
import { getAdminFoldersQuery, getSharedFoldersQuery } from './queries';
import Split from '../split';
import { buildExpressQuery, buildLoopbackQuery } from './queries/builders';
import { renameKey } from '../../utils';

const getUserFolders = (id, isAdmin) =>
    new Promise((resolve, reject) => {
        const useExpressMigration = Split.getBooleanTreatment('use_express_migration_endpoints');
        const migrationQueryBuilder = useExpressMigration ? buildExpressQuery : buildLoopbackQuery;
        const folderQuery = isAdmin ? getAdminFoldersQuery({ queryBuilder: migrationQueryBuilder }) : getSharedFoldersQuery({ ownerId: id, queryBuilder: migrationQueryBuilder });
        const folderRequest = axios.get(folderQuery);
        folderRequest
            .then((folderResponse) => {
                const folders = folderResponse.data;
                if (useExpressMigration) {
                    renameKey(folders, '_id', 'id');
                }
                resolve({ folders });
            })
            .catch((errors) => {
                // eslint-disable-next-line no-console
                console.log(errors);
                reject(new Error('Unable to process request'));
            });
    });

export default getUserFolders;
